import IUserVm from "../models/shared/IUserVm"

export default class UserHelper {
    /**
     * Returns the current user logged in
     */
    public static currentUser(): IUserVm {
        return ((window as any).user as IUserVm)
    }
}